import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setUser(false); setReady(true); return; }
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => { localStorage.removeItem("token"); setUser(false); })
      .finally(() => setReady(true));
  }, []);

  const persist = ({ token, user }) => {
    localStorage.setItem("token", token);
    setUser(user);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, ready, persist, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
